<template>
  <div class="pa-0">
    <!-- Tab Selector -->
    <div v-if="hasPartsAndServices" class="flex justify-center pt-6 pb-2" style="font-family: 'Inter', sans-serif;">
      <div class="inline-flex bg-slate-100 p-1.5 rounded-2xl shadow-inner border border-slate-200/60">
        <button
          @click="activeTab = 'fleet'"
          :class="activeTab === 'fleet' ? 'bg-white text-orange-600 shadow-sm border-slate-200' : 'text-slate-500 hover:text-slate-700 border-transparent'"
          class="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold tracking-wide transition-all duration-200 border"
        >
          <v-icon small :color="activeTab === 'fleet' ? '#ea580c' : '#64748b'">mdi-gas-station</v-icon>
          Abastecimento &amp; Frota
        </button>

        <button
          @click="activeTab = 'parts'"
          :class="activeTab === 'parts' ? 'bg-white text-orange-600 shadow-sm border-slate-200' : 'text-slate-500 hover:text-slate-700 border-transparent'"
          class="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold tracking-wide transition-all duration-200 border"
        >
          <v-icon small :color="activeTab === 'parts' ? '#ea580c' : '#64748b'">mdi-hammer-wrench</v-icon>
          Peças e Serviços
        </button>
      </div>
    </div>

    <!-- Dashboards Rendering -->
    <div>
      <div v-show="activeTab === 'fleet'">
        <Prefecture :prefecture_id="prefecture_id" v-if="prefecture_id" />
        <Master v-else />
      </div>

      <div v-show="activeTab === 'parts'" v-if="hasPartsAndServices">
        <PartsAndServices :prefecture_id="prefecture_id" />
      </div>
    </div>
  </div>
</template>

<script>
import Prefecture from "./dashcomponents/prefectures";
import Master from "./dashcomponents/master";
import PartsAndServices from "./dashcomponents/partsAndServices";

export default {
  components: {
    Prefecture,
    Master,
    PartsAndServices,
  },
  data: () => ({
    prefecture_id: null,
    httpPerms: null,
  }),
  computed: {
    activeTab: {
      get() {
        return this.$route.query.tab === 'parts' ? 'parts' : 'fleet';
      },
      set(val) {
        if (this.$route.query.tab !== val && !(val === 'fleet' && !this.$route.query.tab)) {
          this.$router.push({ query: { ...this.$route.query, tab: val === 'fleet' ? undefined : val } }).catch(()=>{});
        }
      }
    },
    // Propriedade computada reativa - atualiza automaticamente quando o store muda
    hasPartsAndServices() {
      const checkMatch = (title) => {
        if (!title) return false;
        const t = title.toLowerCase();
        return (
          t.includes("peças e serviços") ||
          t.includes("almoxarifado") ||
          t.includes("ordem de serviço") ||
          t.includes("liberação de os")
        );
      };
      // Usar permissões do store (reativas) ou do fallback HTTP
      const storePerms = this.$store.getters.getUserPermissions;
      const perms =
        Array.isArray(storePerms) && storePerms.length > 0
          ? storePerms
          : this.httpPerms || [];
          
      return perms.some((p) => p.show && checkMatch(p.title));
    },
  },
  beforeCreate() {
    if (!sessionStorage.getItem("token")) {
      this.$router.push("/login");
    }
  },
  async created() {
    if (this.$store.getters.getUserData.table_key == "prefectures") {
      this.prefecture_id = this.$store.getters.getUserData.table_id;
    } else if (this.$store.getters.getUserData.table_key == "attendants") {
      this.$router.push("/supplies-manager/attendants");
    } else if (this.$store.getters.getUserData.table_key == "providers") {
      this.$router.push("/supplies-manager/providers");
    }

    // Buscar permissões via HTTP como garantia (caso o store esteja vazio)
    const storePerms = this.$store.getters.getUserPermissions;
    if (!Array.isArray(storePerms) || storePerms.length === 0) {
      try {
        const groupId = this.$store.getters.getUserData.group_id;
        const r = await this.$http.get(`/access-groups/${groupId}`);
        const raw = r.data[0].group_permissions;
        const perms = typeof raw === "string" ? JSON.parse(raw) : raw;
        // Salva no store (reativo) e no fallback local
        this.$store.dispatch("userPermissions", perms);
        this.httpPerms = perms;
      } catch (e) {
        this.httpPerms = [];
      }
    }
  },
};
</script>

<style>
.fslt {
  color: whitesmoke;
  text-transform: uppercase;
}
.fsl {
  font-size: 2rem;
  color: whitesmoke;
  font-weight: 400;
}

@media (max-width: 600px) {
  .fsl {
    font-size: 1.5rem;
  }
  .fslt {
    font-size: 0.8rem;
  }
  .dash-tab-btn span {
    display: none;
  }
}
</style>